import { Listener } from '../listenersStore';

const projectListListeners: Listener = {
  'refresh/project-list': (dispatch: any, action: any) => {
    dispatch({
      type: 'REFRESH_PROJECTS_LIST_START',
      payload: action.payload,
    });
  },
};

export default projectListListeners;
